// システム／ユーザーの左右ペインの分割比（左ペインの幅 %。8:2 まで寄せられる）
export const SPLIT_MIN = 20;
export const SPLIT_MAX = 80;
export const SPLIT_DEFAULT = 50;

/**
 * 分割比を 20〜80 の整数にそろえる（数値にならなければ既定値）
 * @param {number|string} value
 */
export const clampSplit = (value) => {
    const n = typeof value === "string" ? (value.trim() === "" ? NaN : Number(value)) : value;
    if (typeof n !== "number" || !Number.isFinite(n)) return SPLIT_DEFAULT;
    return Math.min(SPLIT_MAX, Math.max(SPLIT_MIN, Math.round(n)));
};

/**
 * 保存しておいたアウトラインの開閉（JSON）を読む。読めない値は閉じた扱い
 * @param {string|null|undefined} raw
 * @returns {{sys:boolean, user:boolean}}
 */
export const parseOutlineState = (raw) => {
    let value = null;
    try {
        value = raw ? JSON.parse(raw) : null;
    } catch (e) {
        value = null;
    }
    const obj = value && typeof value === "object" && !Array.isArray(value) ? value : {};
    return { sys: obj.sys === true, user: obj.user === true };
};

/**
 * 片方のペインだけ適用中の内容に戻す
 * @param {{sys:string, user:string}} pair 編集中の本文
 * @param {{sys:string, user:string}} remote 適用中の本文
 * @param {'sys'|'user'} tab 戻すペイン
 * @returns {{pair:{sys:string, user:string}, clean:boolean}} clean はもう片方も適用中と同じか
 */
export const discardPane = (pair, remote, tab) => {
    const other = tab === "sys" ? "user" : "sys";
    const next = { ...pair, [tab]: remote[tab] || "" };
    return { pair: next, clean: (next[other] || "") === (remote[other] || "") };
};
